// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DUbz","left":"styles_left__3fa4I","desktopActions":"styles_desktopActions__31iF3","title":"styles_title__922qV"};